import { Link } from "react-router-dom";
import { ArrowUpRight, HelpCircle } from "lucide-react";
import FAQSection, { faqs } from "../components/FAQ";
import useSEO from "../lib/seo";

export default function FAQPage() {
  useSEO({
    title: "FAQ — Loan Processing, Eligibility & Documentation",
    description:
      "Frequently asked questions about loan processing, CIBIL score, FOIR, balance transfer, foreclosure, LAP, home loans, business loans and more — answered by DVP DIGI WORLD experts.",
    path: "/faq",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": f.a,
        },
      })),
    },
  });
  return (
    <div data-testid="page-faq">
      {/* HERO */}
      <section className="relative border-b border-white/5">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1d4ed8]/15 via-transparent to-[#dc2626]/15" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 lg:py-24">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#dc2626]">
            Frequently Asked Questions
          </div>
          <h1 className="mt-5 font-display font-bold text-3xl sm:text-4xl lg:text-6xl tracking-tighter text-white max-w-4xl leading-[0.95]">
            Everything about loans, <br />
            answered.
          </h1>
          <p className="mt-6 text-lg text-neutral-300 max-w-3xl leading-relaxed">
            Clear, honest answers to the most common questions about loan
            processing, eligibility, documentation and repayment.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="border border-white/10 rounded-2xl bg-[#0f0f0f] p-6 sm:p-10">
            <FAQSection />
          </div>

          <div className="mt-14 rounded-xl border border-white/10 bg-[#121212] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
            <div className="flex items-start gap-4">
              <div className="h-11 w-11 rounded-lg bg-[#dc2626]/10 border border-[#dc2626]/20 flex items-center justify-center text-[#dc2626] flex-shrink-0">
                <HelpCircle className="h-5 w-5" />
              </div>
              <div>
                <div className="font-display font-bold text-xl text-white">
                  Still have questions?
                </div>
                <p className="text-neutral-400 mt-1 text-sm">
                  Our team is happy to walk you through your options.
                </p>
              </div>
            </div>
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white px-5 py-3 font-semibold whitespace-nowrap"
            >
              Talk to an expert <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
